/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@material-ui/styles";
import Button from "@material-ui/core/Button";

import theme from "../../../../Themes/defaultTheme";
const A_Button = (props) => {
  return (
    <ThemeProvider theme={theme}>
      <Button
        //properties
        style={props.style}
        variant={props.variant}
        color={props.color}
        size={props.size}
        disabled={props.disabled}
        startIcon={props.startIcon}
        endIcon={props.endIcon}
        className={props.className}
        //events
        onClick={props.onClick}
        onDoubleClick={props.onDoubleClick}
        href={props.href}
        target={props.target}
      >
        {props.label}
      </Button>
      {!props.hideSpaceAfterButton && (`\u00A0\u00A0`)}
    </ThemeProvider>
  );
};
A_Button.defaultProps = {
  label: "Button",
  variant: "contained",
  color: "default",
  size: "medium",
  disabled: false,
  style: { textTransform: "none" }
};
A_Button.propTypes = {
  variant: PropTypes.oneOf(["text", "contained", "outlined"]),
  color: PropTypes.oneOf(["default", "inherit", "primary", "secondary", "white"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  startIcon: PropTypes.element,
  endIcon: PropTypes.element,
  hideSpaceAfterButton: PropTypes.bool,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
};
export default A_Button;
